/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdatePromptRequestBody = {
  /**
   * Updated prompt name
   */
  name?: string | undefined;
  /**
   * Updated description — pass null to clear
   */
  description?: string | null | undefined;
  /**
   * Updated metadata — replaces existing
   */
  metadata?: { [k: string]: any } | undefined;
};

export type UpdatePromptRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody: UpdatePromptRequestBody;
};

/** @internal */
export const UpdatePromptRequestBody$inboundSchema: z.ZodType<
  UpdatePromptRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string().optional(),
  description: z.nullable(z.string()).optional(),
  metadata: z.record(z.any()).optional(),
});
/** @internal */
export type UpdatePromptRequestBody$Outbound = {
  name?: string | undefined;
  description?: string | null | undefined;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const UpdatePromptRequestBody$outboundSchema: z.ZodType<
  UpdatePromptRequestBody$Outbound,
  z.ZodTypeDef,
  UpdatePromptRequestBody
> = z.object({
  name: z.string().optional(),
  description: z.nullable(z.string()).optional(),
  metadata: z.record(z.any()).optional(),
});

export function updatePromptRequestBodyToJSON(
  updatePromptRequestBody: UpdatePromptRequestBody,
): string {
  return JSON.stringify(
    UpdatePromptRequestBody$outboundSchema.parse(updatePromptRequestBody),
  );
}
export function updatePromptRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdatePromptRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdatePromptRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdatePromptRequestBody' from JSON`,
  );
}

/** @internal */
export const UpdatePromptRequest$inboundSchema: z.ZodType<
  UpdatePromptRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => UpdatePromptRequestBody$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type UpdatePromptRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody: UpdatePromptRequestBody$Outbound;
};

/** @internal */
export const UpdatePromptRequest$outboundSchema: z.ZodType<
  UpdatePromptRequest$Outbound,
  z.ZodTypeDef,
  UpdatePromptRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => UpdatePromptRequestBody$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function updatePromptRequestToJSON(
  updatePromptRequest: UpdatePromptRequest,
): string {
  return JSON.stringify(
    UpdatePromptRequest$outboundSchema.parse(updatePromptRequest),
  );
}
export function updatePromptRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdatePromptRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdatePromptRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdatePromptRequest' from JSON`,
  );
}
